module.exports = __webpack_public_path__ + "img/xaas-linkedin.74c72b3.png";